(function(){
	"use strict";

	/**
	 * WineFilterFunction
	 * Applies "OR" filter mechanism.
	 */
	angular
		.module('pwc.filters')
		.filter('wineFilterFunction', wineFilterFunction);

	function wineFilterFunction(lodash) {

		return function(wine, selected) {

			var pass = false;

			if (lodash.isEmpty(selected)){
				pass = true;
			}

			switch (selected.slug){
				case 'all':
					pass = true;
					break;

				case 'cellar':
					if (wine.cellar.qty > 0){
						pass = true;
					}
					break;

				case 'oos':
					if (lodash.get(wine, 'cellar.history').length && lodash.get(wine, 'cellar.qty') === 0){
						pass = true;
					}
					break;

				case 'wished':
					pass = wine.cellar.wished;
					break;

				case 'starred':
					pass = wine.cellar.starred;
					break;

				case 'tasted':
					pass = wine.cellar.tasted;
					break;

				case 'ordered':
					pass = wine.cellar.ordered;
					break;
			}

			return pass;
		};
	}

})();
